import { Component, OnInit, ViewEncapsulation ,ViewContainerRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AuthService } from './../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';
import { Series } from './../../models';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-e-comic-series-add',
  templateUrl: './e-comic-series-add.component.html',
  styleUrls: ['./e-comic-series-add.component.css'],
})
export class EComicSeriesAddComponent implements OnInit {
  // variable declarations
  comicseriesForm: FormGroup;
  user: any;
  status: any = true;
  id: any;
  loading: any = false;

  // variables for the images
  thumbnail_image: File;
  cover_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  constructor(
    private form: FormBuilder, private router: Router,
    private afs: AngularFirestore, private auth: AuthService,
    private comics: EcomicService, private route: ActivatedRoute,
    public toastr: ToastsManager,vcr: ViewContainerRef
  ) { this.toastr.setRootViewContainerRef(vcr);
    // checking if router contais any id
    if (this.route.firstChild) {
      this.route.firstChild.params.subscribe(params => { // getting the id from the router link
        this.id = params['id'];
        if (this.id) {
          this.status = false;
          // To get the details of the comic from the database with the use of 'authservice'
          this.comics.getsinglecomic(this.id, 'Ecomicseries').then(data => {
            data.subscribe(singlecomic => {
              console.log(singlecomic);
              const singleseries = singlecomic;
              // Asigning the details to their corresponding fields
              this.comicseriesForm.get('title').setValue(singleseries['title']);
              this.comicseriesForm.get('description').setValue(singleseries['description']);
              this.comicseriesForm.get('seo_title').setValue(singleseries['seo_title']);
              this.comicseriesForm.get('seo_description').setValue(singleseries['seo_description']);
              this.comicseriesForm.get('seo_keyword').setValue(singleseries['seo_keyword']);
              this.comicseriesForm.get('status').setValue(singleseries['status']);
              this.cover_image_url = singleseries['cover_image'];
              this.thumbnail_image_url = singleseries['thumbnail_image'];
              this.status = true;
            });
          });
        }
      });
    }
  }
  async ngOnInit() {
    // Creating the new form with the required fields
    this.comicseriesForm = this.form.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]],
      seo_title: ['', [Validators.required]],
      seo_description: ['', [Validators.required]],
      seo_keyword: ['', [Validators.required]],
      status: ['Inactive', [Validators.required]],
      cover_image: ['', []],
      thumbnail_image: ['', []],
    });
    // Getting the logedin user details from the database
    if (!this.id) {
      this.auth.getuser().then(userdetails => {
        this.user = userdetails;
      });
    }
  }

  async addseries(value, valid) {
    // Enters if the form is valid
    if (valid) {
      this.loading = true; // Initiating the loader
      const series: Series = { // assigning the values to store it in the database
        title: value.title,
        description: value.description,
        seo_title: value.seo_title,
        seo_description: value.seo_description,
        seo_keyword: value.seo_keyword,
        status: value.status,
      };
      try {
        // if the id is present the it goes for the update or else to add the new data
        if (this.id) {
          let thumbnail;
          let coverimage;
          // Checking if the cover image is changed if changed the update the image in sapces and also db.
          if (this.cover_image) {
            coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
            series.cover_image = coverimage['Location'];
          }
          // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
          if (this.thumbnail_image) {
            thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
            series.thumbnail_image = thumbnail['Location'];
          }
          // Updating the changed values to the database
          const document = await this.afs.doc(`/Ecomicseries/${this.id}`);
          const update = await document.update(series);
          // After updating id redirecting to the list page
          this.router.navigate(['/comic-series']);
        // The else part if there is no id then add the new data to the db
        } else {
          // checks if the images is selected if not throws the error
          if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
          if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
          // uploading the images to the spaces and getting the uoloaded location
          const thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
          const coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
          series.thumbnail_image = thumbnail['Location'];
          series.cover_image = coverimage['Location'];
          series.admin = this.user.uid;
          series.addedby = this.user.username;
          series.createdAt = new Date();
          series.date = new Date().toString();
          const eseriesdata = await this.afs.collection('Ecomicseries').add(series);
          const esid = eseriesdata.id;
          const id = await this.afs.doc(`/Ecomicseries/${esid}`).update({ id: esid });
          this.router.navigate(['/comic-series']);
        }
      } catch (error) {
        this.loading = false;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    } else {
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
      console.log('error');
    }
  }

  changeListner1(event) {
    this.thumbnailimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-series-add/e-comic-series-add.component.ts